videojs.addLanguage('hu', {
  "Play": "Lejátszás",
  "Pause": "Szünet",
  "Current Time": "Aktuális időpont",
  "Duration": "Hossz",
  "Remaining Time": "Hátralévő idő",
  "Stream Type": "Adatfolyam típusa",
  "LIVE": "ÉLŐ",
  "Loaded": "Betöltve",
  "Progress": "Állapot",
  "Fullscreen": "Teljes képernyő",
  "Non-Fullscreen": "Normál méret",
  "Mute": "Némítás",
  "Unmute": "Némítás kikapcsolva",
  "Playback Rate": "Lejátszási sebesség",
  "Subtitles": "Feliratok",
  "subtitles off": "Feliratok kikapcsolva",
  "Captions": "Magyarázó szöveg",
  "captions off": "Magyarázó szöveg kikapcsolva",
  "Chapters": "Fejezetek",
  "You aborted the media playback": "Leállította a lejátszást",
  "A network error caused the media download to fail part-way.": "Hálózati hiba miatt a videó részlegesen töltődött le.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "A videó nem tölthető be hálózati vagy kiszolgálói hiba miatt, vagy a formátuma nem támogatott.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "A lejátszás adatsérülés miatt leállt, vagy a videó egyes tulajdonságait a böngészője nem támogatja.",
  "No compatible source was found for this media.": "Nincs kompatibilis forrás ehhez a videóhoz.",
  "Audio Player": "Audio lejátszó",
  "Video Player": "Videó lejátszó",
  "Replay": "Visszajátszás",
  "Descriptions": "Leírások",
  "descriptions off": "leírások kikapcsolva",
  "Audio Track": "Hangsáv",
  "Volume Level": "Hangerő",
  "Play Video": "Videó lejátszása",
  "Close": "Bezárás",
  "Text": "Szöveg",
  "White": "Fehér",
  "Black": "Fekete",
  "Red": "Piros",
  "Green": "Zöld",
  "Blue": "Kék",
  "Yellow": "Sárga",
  "Background": "Háttér",
  "Window": "Ablak",
  "Transparent": "Átlátszó",
  "Semi-Transparent": "Félig átlátszó",
  "Opaque": "Áttetsző",
  "Font Size": "Betűméret",
  "Font Family": "Betűtípus",
  "Done": "Kész",
  "Picture-in-Picture": "Kép a képben",
  "Exit Picture-in-Picture": "Kilépés kép a képben módból",
  "{1} is loading.": "{1} betöltése.",
  "Reset": "Visszaállítás",
  "restore all settings to the default values": "összes beállítás visszaállítása az alapértelmezett értékekre",
  "The media is encrypted and we do not have the keys to decrypt it.": "A média titkosítva van és nincsenek kulcsok a visszafejtéshez.",
  "Close Modal Dialog": "Felugró ablak bezárása",
  "Modal Window": "Felugró ablak",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Ezt a felugró ablakot az Escape gomb megnyomásával vagy a bezáró gomb aktiválásával lehet bezárni.",
  ", selected": ", kiválasztva",
  "descriptions settings": "leírások beállítása",
  "Text Edge Style": "Szövegél stílus",
  "This is a modal window": "Ez egy felugró ablak",
  "Cyan": "Cián",
  "Dropshadow": "Árnyék",
  "End of dialog window.": "Párbeszédablak vége.",
  "Progress Bar": "Folyamatjelző sáv",
  "Beginning of dialog window. Escape will cancel and close the window.": "Párbeszédablak eleje. Az Escape gomb befejezi és bezárja az ablakot.",
  "Caption Settings Dialog": "Feliratbeállítások párbeszédablak",
  ", opens descriptions settings dialog": ", megnyitja a leírások beállításainak párbeszédablakját",
  ", opens captions settings dialog": ", megnyitja a magyarázó szövegek beállításainak párbeszédablakját",
  ", opens subtitles settings dialog": ", megnyitja a feliratok beállításainak párbeszédablakját",
  "Seek to live, currently behind live": "Élő adáshoz tekerés, jelenleg az élő adás mögött van",
  "Seek to live, currently playing live": "Élő adáshoz tekerés, jelenleg az élő adásnál van",
  "progress bar timing: currentTime={1} duration={2}": "{1} / {2}",
  "Magenta": "Lila",
  "Script": "Script",
  "Casual": "Casual",
  "Monospace Serif": "Monospace Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Sans-Serif": "Proportional Sans-Serif",
  "Proportional Serif": "Proportional Serif",
  "Uniform": "Uniform",
  "Small Caps": "Kiskapitális",
  "None": "Egyik sem",
  "captions settings": "magyarázó szövegek beállításai",
  "subtitles settings": "feliratok beállításai",
  "Raised": "Emelt",
  "Depressed": "Nyomott"
});